import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Mutation = {
  __typename?: 'Mutation';
  optOutSms: Scalars['Boolean']['output'];
};


export type MutationOptOutSmsArgs = {
  inviteId: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']['output']>;
};

export type OptOutSmsMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
}>;


export type OptOutSmsMutation = { __typename?: 'Mutation', optOutSms: boolean };


export const OptOutSmsDocument = gql`
    mutation OptOutSms($inviteId: String!) {
  optOutSms(inviteId: $inviteId)
}
    `;

export function useOptOutSmsMutation() {
  return Urql.useMutation<OptOutSmsMutation, OptOutSmsMutationVariables>(OptOutSmsDocument);
};